module.exports = __webpack_public_path__ + "img/jrkj-active.5225f0dc.svg";